/** Environment constants and link builders (hash routing: #/b/:slug, #/m/:token, #/o/:token, #/demo/pay/:id). */
export const APP_NAME = 'Planella Beauty';
export const DEMO_SLUG = 'smadar';

export interface Links {
  booking(slug: string): string;
  manage(token: string): string;
  offer(token: string): string;
  pay(paymentId: string): string;
}

declare const __APP_BASE_URL__: string | undefined;   // set by scripts/build.mjs (esbuild define); '' in the default build

/**
 * `hash` (default): https://host/#/b/slug.  `path`: https://host/b/slug, always rooted at the origin (see src/config/urlmode.ts).
 * Manage/offer/booking links already sent to clients keep working in both modes: a path build converts `/#/b/slug` on arrival.
 */
export function createLinks(base: string, mode: 'hash' | 'path' = 'hash'): Links {
  if (mode === 'path') {
    const origin = (/^[a-z]+:\/\/[^/]+/i.exec(base)?.[0] ?? base.replace(/\/+$/, ''));
    return {
      booking: (slug) => `${origin}/b/${slug}`,
      manage: (token) => `${origin}/m/${token}`,
      offer: (token) => `${origin}/o/${token}`,
      pay: (id) => `${origin}/demo/pay/${id}`,
    };
  }
  const root = base.endsWith('/') ? base : `${base}/`;
  return {
    booking: (slug) => `${root}#/b/${slug}`,
    manage: (token) => `${root}#/m/${token}`,
    offer: (token) => `${root}#/o/${token}`,
    pay: (id) => `${root}#/demo/pay/${id}`,
  };
}

/** Origin + path of the running app, or a placeholder outside the browser. */
export function defaultBaseUrl(): string {
  // Native shells serve the app from https://localhost or capacitor://localhost: links people share must still point at the public site.
  if (typeof __APP_BASE_URL__ !== 'undefined' && __APP_BASE_URL__) return __APP_BASE_URL__;
  const loc = (globalThis as { location?: { origin: string; pathname: string } }).location;
  return loc && loc.origin !== 'null' ? `${loc.origin}${loc.pathname}` : 'https://planella.co.il/';
}
